import * as React from 'react'
import { graphql } from 'gatsby'
import { GatsbyImage } from "gatsby-plugin-image"

import Layout from '../uglib_components/layout'
import { get_optional_field } from '../uglib_utils/utils'

const ArchivesCollectionIntroPage = ( props ) => {
	const data = props.data.node;
	
	const title = data.title;
	const image_data = data.relationships.field_aci_image_1;

	let image = null;
	if (image_data !== null) {
		image = <GatsbyImage className="collection-image ug-lib-image ug-lib-image-right float-right" image={image_data.localFile.childImageSharp.gatsbyImageData} alt={data.field_aci_image_1.alt} placeholder="blurred" />;
	}

	const breadcrumbs = [
		{ 
			url: "",
			title: "Archives",
		},
		{ 
			url: "/archives/our-collections",
			title: "Our Collections",
		}
	]

	function format_types(types) {
		const type_labels = {
			"plans": "Architectural Plans",
			"artifacts": "Artifacts",
			"art": "Artwork",
			"av": "Audiovisual Material",
			"electronic": "Electronic Records",
			"maps": "Maps",
			"micro": "Microfilm",
			"pics": "Photographs",
			"posters": "Posters",
			"published": "Published Material",
			"drawings": "Technical Drawings",
			"unpublished": "Unpublished Material and Manuscripts",
		}

		let labelled_types = types.map((type) => {
			if(!(type in type_labels)) {
				return null;
			}
			return <li>{type_labels[type]}</li>;
		})

		return labelled_types;

	}

	let extent = <></>;
	if (data.field_aci_extent !== null) {
		extent = <>
			<h2>Extent</h2>
			<div dangerouslySetInnerHTML={{__html: data.field_aci_extent.processed}}/>
		</>;
	}

	let access = <></>;
	if (data.field_aci_how_to_access !== null) {
		access = <>
			<h2>How to Access This Resource</h2>
			<div dangerouslySetInnerHTML={{__html: data.field_aci_how_to_access.processed}}/>
		</>
	}

	const body = get_optional_field(data, 'body.processed');

	const render_types = () => {
		if (data.field_aci_types.length > 0) {
			return(<>
				<h2>Types of Materials</h2>
				<ul>
					{format_types(data.field_aci_types)}
				</ul>	
			</>);
		}
		else {
			return <></>;
		}
	};

    return (
      <Layout breadcrumbs={breadcrumbs} title={title} bodyClass='collection-introduction'>
		<>
			<span>
				{ /**** News story image ****/ }
				{image}

				{ /**** Legacy body field ****/}
				<span dangerouslySetInnerHTML={{__html: body}} />

				<h2>Dates</h2>
				<div>{data.field_aci_dates}</div>

				{/** Types of materials */}
				{render_types()}

				{extent}
				
				{access}
			</span>
		</>
      </Layout>
    )
}

export const query = graphql`
  	query ($id: String) {
		node: nodeArchivesCollectionIntroPage(
			id: {eq: $id}
		) {
			title
			body {
				processed
			}
			id
			changed
			created
			field_aci_image_1 {
				alt
				title
			}
			relationships {
				field_aci_image_1 {
					localFile {
						publicURL
						childImageSharp {
							gatsbyImageData
						}
					}
				}
			}
			field_aci_dates
			field_aci_short_description
			field_aci_types
			field_aci_extent {
				processed
			}
			field_aci_how_to_access {
				processed
			}
			field_published
		}
		
  	}
`

export default ArchivesCollectionIntroPage